import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="audio-signatures"
export default class extends Controller {
  static values = { signatures: Object }
  
  connect() {
    // Apply signatures as soon as the controller connects
    this.applySignatures()
  }

  applySignatures() {
    const signatures = this.signaturesValue

    if (!signatures || Object.keys(signatures).length === 0) {
      return
    }

    // Apply signatures to audio links and player buttons
    Object.keys(signatures).forEach(audioFileId => {
      const signature = signatures[audioFileId]

      // Find all links that contain the audio file ID in their href
      // Pattern: /audio_files/[audioFileId]/play or /audio_files/[audioFileId]/download
      // ONLY apply signatures if the link doesn't already have one
      const links = document.querySelectorAll(`a[href*="/audio_files/${audioFileId}/"]`)
      links.forEach(link => {
        const currentHref = link.getAttribute('href')
        // Skip if already has a signature parameter
        if (currentHref && !currentHref.includes('?s=') && !currentHref.includes('&s=')) {
          // Check if there's already a query string
          const separator = currentHref.includes('?') ? '&' : '?'
          link.setAttribute('href', `${currentHref}${separator}s=${signature}`)
        }
      })

      // Also check for data-audio-file-id attributes (if any exist)
      const dataIdLinks = document.querySelectorAll(`a[data-audio-file-id="${audioFileId}"]`)
      dataIdLinks.forEach(link => {
        const currentHref = link.getAttribute('href')
        if (currentHref && !currentHref.includes('?s=') && !currentHref.includes('&s=')) {
          const separator = currentHref.includes('?') ? '&' : '?'
          link.setAttribute('href', `${currentHref}${separator}s=${signature}`)
        }
      })

      // Handle player buttons and links with data-player-audio-url-param
      const playerElements = document.querySelectorAll(`[data-player-audio-url-param*="/audio_files/${audioFileId}/"]`)
      playerElements.forEach(element => {
        const currentUrl = element.getAttribute('data-player-audio-url-param')
        if (currentUrl && !currentUrl.includes('?s=') && !currentUrl.includes('&s=')) {
          const separator = currentUrl.includes('?') ? '&' : '?'
          element.setAttribute('data-player-audio-url-param', `${currentUrl}${separator}s=${signature}`)
        }
      })

      // Handle any audio source elements
      const sources = document.querySelectorAll(`source[src*="/audio_files/${audioFileId}/"]`)
      sources.forEach(source => {
        const currentSrc = source.getAttribute('src')
        if (currentSrc && !currentSrc.includes('?s=') && !currentSrc.includes('&s=')) {
          const separator = currentSrc.includes('?') ? '&' : '?'
          source.setAttribute('src', `${currentSrc}${separator}s=${signature}`)
        }
      })

      // Handle data-src attributes (for lazy loading)
      const dataSrcElements = document.querySelectorAll(`[data-src*="/audio_files/${audioFileId}/"]`)
      dataSrcElements.forEach(element => {
        const currentDataSrc = element.getAttribute('data-src')
        if (currentDataSrc && !currentDataSrc.includes('?s=') && !currentDataSrc.includes('&s=')) {
          const separator = currentDataSrc.includes('?') ? '&' : '?'
          element.setAttribute('data-src', `${currentDataSrc}${separator}s=${signature}`)
        }
      })
    })

    // Trigger a custom event that other parts of the app can listen to
    this.element.dispatchEvent(new CustomEvent('signatures:applied', { 
      detail: { signatures },
      bubbles: true 
    }))
  }

  // Public method that can be called if signatures need to be reapplied
  refresh() {
    this.applySignatures()
  }
}